import React from 'react';
import {
  createStyles,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import StyledTableCell from '../../Global/Tables/StyledTableCell';
import StyledLinkIconButton from '../../Global/Buttons/StyledLinkIconButton';
import { ArrowDropDown, ArrowDropUp, Home } from '@material-ui/icons';
import { getResearchApiUrlForPlay, getStatsApiUrlLiveGameWithStrikeZoneAnalytics } from '../../../utils/shared-links';
import PlayDetailsDialog from '../../BatRack/PlayLookupPage/PlayDetails/PlayDetailsDialog';
import {
  PitchChallenge,
  GamePitchChallenges,
  PITCH_CHALLENGE_RESULT,
  ChallengeType,
} from '../../../types/PitchChallenge';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .MuiSvgIcon-root': {
        verticalAlign: 'text-bottom',
      },
    },
  }),
);

const columnNames = [
  'Inning',
  'Challenged By',
  'Batter',
  'Pitcher',
  'Pitch Call',
  'Challenge Result',
  'Play ID',
  'Research',
  'GUIDs',
];

type TabsChallengedPlayTableProps = {
  gamePitchChallenges: GamePitchChallenges;
  challengeType: ChallengeType;
};

const ChallengedPlayTable: React.FC<TabsChallengedPlayTableProps> = ({ gamePitchChallenges, challengeType }) => {
  const classes = useStyles();

  const pitchCall = (challenge: PitchChallenge): string => {
    if (challenge.challengeResult === PITCH_CHALLENGE_RESULT.UPHELD) {
      return challenge.playResult;
    } else {
      return challenge.playResult === 'Ball' ? 'Called Strike' : 'Ball';
    }
  };

  const pitchChallengeTeamCode = (teamId: number) => {
    return teamId === gamePitchChallenges.awayTeamId
      ? gamePitchChallenges.awayTeam.code
      : gamePitchChallenges.homeTeam.code;
  };

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {columnNames.map(columnName => (
                <StyledTableCell key={columnName}>{columnName}</StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {gamePitchChallenges.pitchChallenges.map(challenge => (
              <TableRow key={challenge.playId}>
                <TableCell>
                  {challenge.inning}
                  {challenge.halfInning === 'top' ? <ArrowDropUp /> : <ArrowDropDown />}
                </TableCell>
                <TableCell>{pitchChallengeTeamCode(challenge.challengeTeamId)}</TableCell>
                <TableCell>
                  {challenge.batterName} {challenge.halfInning === 'bottom' ? <Home fontSize='small' /> : ''}
                </TableCell>
                <TableCell>
                  {challenge.pitcherName} {challenge.halfInning === 'top' ? <Home fontSize='small' /> : ''}
                </TableCell>
                <TableCell>{pitchCall(challenge)}</TableCell>
                <TableCell>{challenge.challengeResult}</TableCell>
                <TableCell>
                  <PlayDetailsDialog playId={challenge.playId} />
                </TableCell>
                <TableCell align='center'>
                  <StyledLinkIconButton
                    linkUrl={`${getResearchApiUrlForPlay(gamePitchChallenges.gamePk, challenge.playId)}#${
                      challengeType === 'ABS' ? 'media=pitch-view' : 'media=video'
                    }`}
                  />
                </TableCell>
                <TableCell align='center'>
                  <StyledLinkIconButton
                    linkUrl={getStatsApiUrlLiveGameWithStrikeZoneAnalytics(gamePitchChallenges.gamePk)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ChallengedPlayTable;
